import { Box } from "@mui/material";
import React from "react";
import styles from "./ActivityList.module.css";
import moment from "moment";
import stageDot from "../../assets/images/stage-dot.svg";
import nameLine from "../../assets/images/name-line.svg";
import getTeamMember from "../CommonFunctions/CommonFunctions";

function ActivityVoxbayCall(props: any) {
  const { data, employees, selectedLeadData } = props;

  const urlParams = new URLSearchParams(window.location.search);
  const leadActivityId = urlParams.get("leadActivityId");

  return (
    <Box
      sx={{
        width: "100%",
        margin: "0 15px 22px 15px",
        background: leadActivityId === data?.id ? "#e8faf6" : "transparent",
        padding: leadActivityId === data?.id ? "0 5px 5px 5px" : "0px",
        borderRadius: leadActivityId === data?.id ? "4px" : "0px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className={styles.activityTop}>
          <div className={styles.activityDateStyle}>
            {moment(data?.creationDate).format("DD MMM YYYY, hh:mm A")}
          </div>
          <div className={styles.activityHeadStage}>
            <div className={styles.activityHeadStageIcon}>
              <img src={stageDot} alt="" />
            </div>
            <div>
              {selectedLeadData?.enquirySwimlaneStatus === "NEW_ENQUIRY"
                ? "New Enquiry"
                : selectedLeadData?.enquirySwimlaneStatus === "CONTACTED"
                ? "Contacted"
                : selectedLeadData?.enquirySwimlaneStatus === "DEMO"
                ? "Demo"
                : selectedLeadData?.enquirySwimlaneStatus === "NEGOTIATION"
                ? "Negotiation"
                : selectedLeadData?.enquirySwimlaneStatus === "CONVERTED"
                ? "Converted"
                : ""}
            </div>
          </div>
          <div className={styles.activityHeadName}>
            <div className={styles.activityHeadStageIcon}>
              <img src={nameLine} alt="" />
            </div>
            <div>
              {/* {data?.createdByName} */}
              {getTeamMember(data?.createdById, employees)?.firstName +
                " " +
                getTeamMember(data?.createdById, employees)?.lastName}
            </div>
          </div>
        </div>

        <div
          className={styles.activityStageDesc}
          style={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          <div
            className={styles.activityDemoTitle}
            style={{
              marginBottom: 0,
              color:
                data?.activityType === "OZONE_MISSED_CALL" ||
                data?.activityType === "VOXBAY_MISSED_CALL"
                  ? "#EC3939"
                  : data?.activityType === "OZONETEL_MISSED_CALL"
                  ? "#EC3939"
                  : "#142C44",
            }}
          >
            {data?.callDetails?.callType === "OUTGOING"
              ? "Call Outgoing"
              : data?.callDetails?.callType === "INCOMING"
              ? "Call Incoming"
              : ""}
          </div>

          {
            <div
              className={styles.activityStatusBox}
              style={{
                background:
                  data?.callDetails?.callStatus === "BUSY" ||
                  data?.callDetails?.callStatus === "CANCEL" ||
                  data?.callDetails?.callStatus === "FAILED"
                    ? "#FEF3F3"
                    : "rgba(17, 200, 155, 0.06)",
                color:
                  data?.callDetails?.callStatus === "BUSY" ||
                  data?.callDetails?.callStatus === "CANCEL" ||
                  data?.callDetails?.callStatus === "FAILED"
                    ? "#EC3939"
                    : "#11C89B",
              }}
            >
              {data?.callDetails?.callStatus === "BUSY" ||
              data?.callDetails?.callStatus === "CANCEL" ||
              data?.callDetails?.callStatus === "FAILED"
                ? "Unanswered"
                : data?.callDetails?.callStatus === "ANSWER"
                ? "Answer"
                : "Answered"}
            </div>
          }
        </div>

        {(data?.callDetails?.callStatus === "ANSWER" ||
          data?.callDetails?.callStatus === "ANSWERED") && (
          <div
            className={styles.activityDescription}
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            Call Recording :
            <audio
              controls
              style={{
                width: "150px",
                height: "28px",
              }}
            >
              <source
                src={data?.callDetails?.callRecordingUrl}
                type="audio/ogg"
              />
              {/* Your browser does not support the audio element. */}
            </audio>
          </div>
        )}

        <div className={styles.activityDescription}>
          Reason: {data?.category ? data?.category : "-"}
        </div>
        <div className={styles.activityDescription}>
          Comment: {data?.comment ? data?.comment : "-"}
        </div>
      </Box>
    </Box>
  );
}

export default ActivityVoxbayCall;
